import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    firstName: {
      validations: [
        { type: 'required', message: 'Please provide a first name' }
      ]
    },
    lastName: {
      validations: [
        { type: 'required', message: 'Please provide a last name' }
      ]
    },
    ClientName: {
        validations: [
            { type: 'required', message: 'Please fill in required field.' }
        ]
    },
    telNumber: {
      validations: [
        { type: 'required', message: 'Please provide a phone number' },
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number' }
      ]
    },
    email: {
      validations: [
        { type: 'required', message: 'Please provide an email' },
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email' }
      ]
    },
    AddressLine1: {
        validations: [
          { type: 'required', message: 'Please provide an address' },
        ]
    },
    City: {
        validations: []
    },
    State: {
        validations: []
    },
    Postal: {
        validations: [
            { type: 'maxLength', maxLength: 5, message: 'Enter 5 digit zip code' }
        ]
      },
      eventDate: {
        validations: [
          { type: 'required', message: 'Please provide an event date' },
          { type: 'dateinfuture', message: 'Event date must be in the future' }
        ]
      },
      StartTime: {
          validations: [
            { type: 'required', message: 'Please provide a start time' },
          ]
      },
      EndTime: {
          validations: [
            { type: 'required', message: 'Please provide an end time' },
          ]
    },
    eventextra2: {
      validations: [
        { type: 'dateinfuture', message: 'Event date must be in the future' }
      ]
    },
    theme: {
      validations: [
        { type: 'required', message: 'Please provide an event type' },
      ]
    },
    plannedguestcount: {
      validations: [
        { type: 'required', message: 'Please provide a guest count' },
      ]
    },
    Operation: {
        validations: []
      },
      eventextra6: {
        validations: [
          { type: 'required', message: 'Please provide a selection' },
        ]
      },
      eventextra7: {
        validations: [
          { type: 'required', message: 'Please provide a selection' },
        ]
      },
      eventextra1: {
          validations: [
            { type: 'required', message: 'Please provide a selection' },
          ]
        },
        Description: {
            validations: [
              { type: 'required', message: 'Please provide a selection' },
            ]
    },
    notes: {
      validations: []
    }
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'First Name:*',
            mapping: 'firstName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Last Name:*',
            mapping: 'lastName'
          }
        ]
      },
      {
        fields: [
            {
            type: 'text',
            size: 'Medium',
            label: 'Client/Organization:*',
            mapping: 'ClientName'
        }
    ]
    },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Phone:*',
            mapping: 'telNumber'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Email:*',
            mapping: 'email'
          },
        ]
      },
      {
        fields: [
            {
            type: 'text',
            size: 'Medium',
            label: 'Address:*',
            mapping: 'AddressLine1'
        }
    ]
    },
    {
        fields: [
            {
            type: 'text',
            size: 'Medium',
            label: 'City:',
            mapping: 'City'
        }
    ]
    },
    {
        fields: [
            {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'State:',
            options: [
                { label: 'AL', value: 'AL' },
                { label: 'AK', value: 'AK' },
                { label: 'AZ', value: 'AZ' },
                { label: 'AR', value: 'AR' },
                { label: 'CA', value: 'CA' },
                { label: 'CO', value: 'CO' },
                { label: 'CT', value: 'CT' },
                { label: 'DE', value: 'DE' },
                { label: 'DC', value: 'DC' },
                { label: 'FL', value: 'FL' },
                { label: 'GA', value: 'GA' },
                { label: 'HI', value: 'HI' },
                { label: 'ID', value: 'ID' },
                { label: 'IL', value: 'IL' },
                { label: 'IN', value: 'IN' },
                { label: 'IA', value: 'IA' },
                { label: 'KS', value: 'KS' },
                { label: 'KY', value: 'KY' },
                { label: 'LA', value: 'LA' },
                { label: 'ME', value: 'ME' },
                { label: 'MD', value: 'MD' },
                { label: 'MA', value: 'MA' },
                { label: 'MI', value: 'MI' },
                { label: 'MN', value: 'MN' },
                { label: 'MS', value: 'MS' },
                { label: 'MO', value: 'MO' },
                { label: 'MT', value: 'MT' },
                { label: 'NE', value: 'NE' },
                { label: 'NV', value: 'NV' },
                { label: 'NH', value: 'NH' },
                { label: 'NJ', value: 'NJ' },
                { label: 'NM', value: 'NM' },
                { label: 'NY', value: 'NY' },
                { label: 'NC', value: 'NC' },
                { label: 'ND', value: 'ND' },
                { label: 'OH', value: 'OH' },
                { label: 'OK', value: 'OK' },
                { label: 'OR', value: 'OR' },
                { label: 'PA', value: 'PA' },
                { label: 'RI', value: 'RI' },
                { label: 'SC', value: 'SC' },
                { label: 'SD', value: 'SD' },
                { label: 'TN', value: 'TN' },
                { label: 'TX', value: 'TX' },
                { label: 'UT', value: 'UT' },
                { label: 'VT', value: 'VT' },
                { label: 'VA', value: 'VA' },
                { label: 'WA', value: 'WA' },
                { label: 'WV', value: 'WV' },
                { label: 'WI', value: 'WI' },
                { label: 'WY', value: 'WY' }
            ],
            mapping: 'State'
        }
    ]
    },
    {
        fields: [
            {
            type: 'text',
            size: 'Medium',
            label: 'Zip:',
            mapping: 'Postal'
        }
    ]
    },
    {
        fields: [
            {
            type: 'date-picker-nofill',
            size: 'Medium',
            label: 'Event Date:*',
            mapping: 'eventDate'
        }
    ]
    },
    {
      fields: [
          {
          type: 'multiple-choice',
          size: 'Medium',
          label: 'Start Time:*',
          options: [
            { label: '7:00 AM', value: '07:00:00' },
              { label: '7:30 AM', value: '07:30:00' },
              { label: '8:00 AM', value: '08:00:00' },
              { label: '8:30 AM', value: '08:30:00' },
              { label: '9:00 AM', value: '09:00:00' },
              { label: '9:30 AM', value: '09:30:00' },
              { label: '10:00 AM', value: '10:00:00' },
              { label: '10:30 AM', value: '10:30:00' },
              { label: '11:00 AM', value: '11:00:00' },
              { label: '11:30 AM', value: '11:30:00' },
              { label: '12:00 PM', value: '12:00:00' },
              { label: '12:30 PM', value: '12:30:00' },
              { label: '1:00 PM', value: '13:00:00' },
              { label: '1:30 PM', value: '13:30:00' },
              { label: '2:00 PM', value: '14:00:00' },
              { label: '2:30 PM', value: '14:30:00' },
              { label: '3:00 PM', value: '15:00:00' },
              { label: '3:30 PM', value: '15:30:00' },
              { label: '4:00 PM', value: '16:00:00' },
              { label: '4:30 PM', value: '16:30:00' },
              { label: '5:00 PM', value: '17:00:00' },
              { label: '5:30 PM', value: '17:30:00' },
              { label: '6:00 PM', value: '18:00:00' },
              { label: '6:30 PM', value: '18:30:00' },
              { label: '7:00 PM', value: '19:00:00' },
              { label: '7:30 PM', value: '19:30:00' },
              { label: '8:00 PM', value: '20:00:00' },
              { label: '8:30 PM', value: '20:30:00' },
              { label: '9:00 PM', value: '21:00:00' },
              { label: '9:30 PM', value: '21:30:00' },
              { label: '10:00 PM', value: '22:00:00' },
              { label: '10:30 PM', value: '22:30:00' },
              { label: '11:00 PM', value: '23:00:00' },
              { label: '11:30 PM', value: '23:30:00' },
          ],
          mapping: 'StartTime'
      }
  ]
  },
  {
      fields: [
          {
          type: 'multiple-choice',
          size: 'Medium',
          label: 'End Time:*',
          options: [
            { label: '7:00 AM', value: '07:00:00' },
              { label: '7:30 AM', value: '07:30:00' },
              { label: '8:00 AM', value: '08:00:00' },
              { label: '8:30 AM', value: '08:30:00' },
              { label: '9:00 AM', value: '09:00:00' },
              { label: '9:30 AM', value: '09:30:00' },
              { label: '10:00 AM', value: '10:00:00' },
              { label: '10:30 AM', value: '10:30:00' },
              { label: '11:00 AM', value: '11:00:00' },
              { label: '11:30 AM', value: '11:30:00' },
              { label: '12:00 PM', value: '12:00:00' },
              { label: '12:30 PM', value: '12:30:00' },
              { label: '1:00 PM', value: '13:00:00' },
              { label: '1:30 PM', value: '13:30:00' },
              { label: '2:00 PM', value: '14:00:00' },
              { label: '2:30 PM', value: '14:30:00' },
              { label: '3:00 PM', value: '15:00:00' },
              { label: '3:30 PM', value: '15:30:00' },
              { label: '4:00 PM', value: '16:00:00' },
              { label: '4:30 PM', value: '16:30:00' },
              { label: '5:00 PM', value: '17:00:00' },
              { label: '5:30 PM', value: '17:30:00' },
              { label: '6:00 PM', value: '18:00:00' },
              { label: '6:30 PM', value: '18:30:00' },
              { label: '7:00 PM', value: '19:00:00' },
              { label: '7:30 PM', value: '19:30:00' },
              { label: '8:00 PM', value: '20:00:00' },
              { label: '8:30 PM', value: '20:30:00' },
              { label: '9:00 PM', value: '21:00:00' },
              { label: '9:30 PM', value: '21:30:00' },
              { label: '10:00 PM', value: '22:00:00' },
              { label: '10:30 PM', value: '22:30:00' },
              { label: '11:00 PM', value: '23:00:00' },
              { label: '11:30 PM', value: '23:30:00' },
          ],
          mapping: 'EndTime'
      }
  ]
  },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'If you have date flexibility, please list your alternate dates:',
            mapping: 'eventextra2'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Type of Event:*',
            options: [
              { label: 'Class', value: 'Class' },
              { label: 'Conference', value: 'Conference' },
              { label: 'Film Screening', value: 'Film Screening' },
              { label: 'Lecture', value: 'Lecture' },
              { label: 'Lecture & Reception', value: 'Lecture & Reception' },
              { label: 'Reception', value: 'Reception' },
              { label: 'Memorial', value: 'Memorial' },
              { label: 'Performance', value: 'Performance' },
              { label: 'Wedding/Wedding Reception', value: 'Wedding/Wedding Reception' },
              { label: 'Webinar/Virtual Event', value: 'Webinar/Virtual Event' },
              { label: 'Hybrid Event', value: 'Hybrid Event' },
              { label: 'Other', value: 'Other' },
          ],
            mapping: 'theme'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Number of People:*',
            mapping: 'plannedguestcount'
          }
        ]
      },
      {
        fields: [
            {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Room:',
            options: [
	{ label: '1st Floor', value: '1st Floor' },
	{ label: '2nd Floor', value: '2nd Floor' },
	{ label: 'Full Venue', value: 'Full Venue' },
              { label: 'Goldman Theater', value: 'Goldman Theater' },
              { label: 'Hazel Wolf Gallery', value: 'Hazel Wolf Gallery' },
              { label: 'Kinzie Room', value: 'Kinzie Room' },
              { label: 'Tamalpais Room', value: 'Tamalpais Room' },
              { label: 'Terrace', value: 'Terrace' },
          ],
            mapping: 'Operation'
        }
    ]
    },
    {
      fields: [
        {
          type: 'multiple-choice',
          size: 'Medium',
          label: 'Do you plan to serve food:*',
          options: [
            { label: 'Yes, food', value: 'Yes, food' },
            { label: 'No food', value: 'No food' },
        ],
          mapping: 'eventextra6'
        }
      ]
    },
    {
      fields: [
        {
          type: 'multiple-choice',
          size: 'Medium',
          label: 'Are you planning to serve alcoholic beverages?:',
          options: [
            { label: 'Yes,  alcohol', value: 'Yes,  alcohol'},
            { label: 'No alcohol', value: 'No alcohol' },
        ],
          mapping: 'eventextra7'
        }
      ]
    },
    {
      fields: [
          {
          type: 'multiple-choice',
          size: 'Medium',
          label: 'Are you inquiring on behalf of a nonprofit organization, a for-profit organization, or as an Individual?*:',
          options: [
            { label: 'Nonprofit', value: 'Nonprofit' },
            { label: 'For-Profit', value: 'For-Profit' },
            { label: 'Individual', value: 'Individual' },
        ],
          mapping: 'eventextra1'
      }
  ]
  },
  {
    fields: [
        {
        type: 'multiple-choice',
        size: 'Medium',
        label: 'How did you hear about the Brower Center?:*',
        options: [
          { label: 'Web search', value: 'Web search' },
          { label: 'Repeat Client', value: 'Repeat Client' },
          { label: 'Tenant Referral', value: 'Tenant Referral' },
          { label: 'Attended Event at DBC', value: 'Attended Event at DBC' },
          { label: 'Yelp!', value: 'Yelp!' },
          { label: 'Vendor Referral', value: 'Vendor Referral' },
          { label: 'Social Media', value: 'Social Media' },
          { label: 'Advertisement', value: 'Advertisement' },
          { label: 'Brower Center Email', value: 'Brower Center Email' },
          { label: 'Other', value: 'Other' },
          { label: 'N/A', value: 'N/A' },
      ],
        mapping: 'Description'
    }
]
},
      {
        fields: [
          {
            type: 'text-area',
            size: 'Medium',
            label: 'Please use this space to share any additional information or questions about your event:',
            mapping: 'notes'
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'Submit'
          }
        ]
      }
    ]
  },
  info: {
    title: 'David Brower Center Contact Form',
    formId: '827',
    clientKey: '9A7F31D3-A76A-48CD-B6F4-8DB336145F7B',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: 'https://browercenter.org/rentals/thank-you-for-submitting-an-inquiry/',
    submissionText: '',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;
